module.exports = "/_next/static/images/step3-cc982c18d9c84525fccea82e7e8a03ff.svg";